import React from 'react'
import {
  availJsonSchema,
  availUiSchema,
  dateJsonSchema,
  dateUiSchema,
  fileJsonSchema,
  fileUiSchema,
  rulesJsonSchema,
  rulesJsonSchemaForDays,
  rulesUiSchema,
  rulesUiSchemaForDays,
} from '@/containers/ReviewBulkPointModifiers/ReviewBulkPointJSON'
import { Link } from '@/components/atoms'
import { PageContainer } from '@/components/organisms'
import { SectionTitle } from '@/components/molecules'
import JsonFormsWrapper from '@/components/common/jsonForms/jsonFormsWrapper/JsonFormsWrapper'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from '@/utils/constants/routesConstants'
import { useAppDispatch, useAppSelector } from '@/store'
import { setBulkModifiers } from '@/store/slices/bulkPointSlice'

const ReviewBulkPoint = ({ bulkPointModifierId }) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()

  const bulkModifier = useAppSelector(state => state?.bulkModifiers)
  const {
    actions = '',
    startDate = '',
    schedule = '',
    storeSelector = '',
    bulkModifierName = '',
    file = '',
    name = '',
    numberOfPoints = '',
    numberOfDays = '',
    endDate = '',
  } = bulkModifier

  // Helper component to render each section
  const RenderSection = ({ id, label, jsonSchema, uiSchema, data }) => (
    <div>
      <SectionTitle isBorderVisible={true} id={id} label={label} />
      <div className="pt-5">
        <JsonFormsWrapper jsonschema={jsonSchema} uischema={uiSchema} data={data} />
      </div>
    </div>
  )
  return (
    
    <PageContainer data-testid="review-bulk-point-modifiers-content" className="review-bulk-modifiers">
     
    {!bulkPointModifierId && (
        <div className="relative">
          <div data-testid="targetSetupEdit">
            <span className="absolute right-0">
              <Link
                label="Edit Section"
                iconLeading="edit"
                onClick={() => {
                  const updatedBulkModifier = { ...bulkModifier, targetMediaFile: [bulkModifier?.file], storeList: bulkModifier?.file }
                  dispatch(setBulkModifiers(updatedBulkModifier))
                  navigate(ROUTES.BULK_POINT_MODIFIER_CREATE)
                }}
              />
            </span>
          </div>
        </div>)}
      <div className="mt-[29px] text-base font-bold">Bulk Modifier Setup </div>
      <RenderSection
        id="review"
        label=""
        jsonSchema={dateJsonSchema}
        uiSchema={dateUiSchema}
        data={{
          eventName: bulkModifierName || name,
          storeSelector: storeSelector,
        }}
      />
      <div className="mt-[29px] text-base font-bold">Rules </div>
      <RenderSection
        id="review"
        label=""
        jsonSchema={actions === 'Remove All Except' ? rulesJsonSchemaForDays : rulesJsonSchema}
        uiSchema={actions === 'Remove All Except' ? rulesUiSchemaForDays : rulesUiSchema}
        data={{
          action: actions,
          numberOfPoints: numberOfPoints,
          numberOfDays: numberOfDays,
        }}
      />

      <div className="mt-[29px] text-base font-bold">Availability </div>
      <RenderSection
        id="review"
        label=""
        jsonSchema={availJsonSchema}
        uiSchema={availUiSchema}
        data={{
          schedule: schedule,
          date: startDate || endDate,
        }}
      />

      <div className="mt-[29px] text-base font-bold">File </div>
      <RenderSection
        id="review"
        label=""
        jsonSchema={fileJsonSchema}
        uiSchema={fileUiSchema}
        data={{
          template: file,
        }}
      />
    </PageContainer>
  )
}

export default ReviewBulkPoint
